module.exports = __webpack_public_path__ + "static/media/image2.433af22d.png";